import { CANDIDATE_TEST_EVENTS } from '../../constants/events';

export const initializeContext = (payload) => ({
  type: CANDIDATE_TEST_EVENTS.INITIALIZE_CONTEXT,
  payload
});

export const showNextSurveyQuestion = () => ({
  type: CANDIDATE_TEST_EVENTS.SHOW_NEXT_SURVEY_QUESTION,
  payload: {}
});

export const showPreviousSurveyQuestion = () => ({
  type: CANDIDATE_TEST_EVENTS.SHOW_PREVIOUS_SURVEY_QUESTION,
  payload: {}
});

export const updateContext = payload => ({
  type: CANDIDATE_TEST_EVENTS.UPDATE_CONTEXT,
  payload
});

export const changeTab = newTab => ({
  type: CANDIDATE_TEST_EVENTS.CHANGE_TAB,
  payload: {
    currentTab: newTab
  }
});

export const startTest = () => ({
  type: CANDIDATE_TEST_EVENTS.START_TEST,
  payload: {}
});

export const showResponse = payload => ({
  type: CANDIDATE_TEST_EVENTS.SHOW_RESPONSE,
  payload
});

export const showNextResponseScreen = () => ({
  type: CANDIDATE_TEST_EVENTS.SHOW_NEXT_RESPONSE_SCREEN,
  payload: {}
});

export const setFinalFeedBackAnswer = (answerObject) => ({
  type: CANDIDATE_TEST_EVENTS.SET_FINAL_FEEDBACK_ANSWER,
  payload: {
    finalFeedbackAnswer: answerObject
  }
});

export const setRedirectURL = (redirectURL) => ({
  type: CANDIDATE_TEST_EVENTS.SET_REDIRECT_URL,
  payload: {
    redirectURL
  }
});

export const setError = message => ({
  type: CANDIDATE_TEST_EVENTS.SET_ERROR,
  payload: {
    message
  }
});



// WEBPACK FOOTER //
// ../q-jobs/src/actions/CandidateTestActions/index.js